export function filterTrips (trips, query) {
    if (!query.trim()) return trips;

    const q = query.toLowerCase();
    return trips.filter((trip) =>
        `${trip.title} ${trip.location}`.toLowerCase().includes(q)
    );
}